import ChevronLeft from './ChevronLeft'

export default ChevronLeft
// eslint-disable-next-line import/export
export * from './ChevronLeft'
